/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */

import type { AuthenticationToken } from '@abc-map/shared';

export enum ActionType {
  Login = 'Authentication-Login',
}

export interface Login {
  type: ActionType.Login;
  token: AuthenticationToken;
  tokenString: string;
}

export type AuthenticationAction = Login;

export class AuthenticationActions {
  public static login(token: AuthenticationToken, tokenString: string): AuthenticationAction {
    return {
      type: ActionType.Login,
      token,
      tokenString,
    };
  }
}
